module.exports = __webpack_public_path__ + "static/media/seal.a5c56e2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals/MT/seal.png
// module id = 1490
// module chunks = 0